import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';

const LoginPage = ({ 
  onLogin, 
  onRegister, 
  onForgotPassword, // New prop
  error, 
  isLoading, 
  recoveryMessage, // New prop
  recoveryError,   // New prop
  onBack 
}) => {
  const [isLoginMode, setIsLoginMode] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [showRecoveryForm, setShowRecoveryForm] = useState(false); // New state for password recovery

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isLoginMode) {
      onLogin({ email, password });
    } else {
      onRegister({ email, password, name });
    }
  };

  const handlePasswordRecovery = async (e) => {
    e.preventDefault();
    // console.log("Password recovery initiated for:", email);
    // TODO: Implement actual password recovery API call
    // After initiating recovery, perhaps show a message and hide the form
    await onForgotPassword(email);
    // setShowRecoveryForm(false); // We can keep the form open to display the message
  };

  return (
    <div className="login-page">
      {onBack && (
        <button className="back-to-home" onClick={onBack}>
          <ArrowLeft size={18} />
          <span className="btn-text">Back to Home</span>
        </button>
      )}
      
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-logo">
            <img src="/logo.ico" alt="LogHog" className="auth-logo-icon" />
            {/* add vertical seperator */}
            <div className="auth-logo-separator"></div>
            {/* add loghog slogan */}
            <span>THE LOGGING TOOL FOR EVERYONE</span>
          </div>
          
          <h2 className="auth-title">
            {isLoginMode ? 'Welcome Back' : 'Create Account'}
          </h2>
          <p className="auth-subtitle">
            {isLoginMode 
              ? 'Sign in to continue to your LogHog dashboard.' 
              : 'Get started with real-time log monitoring.'}
          </p>
          
          {!showRecoveryForm ? (
            <form onSubmit={handleSubmit} className="auth-form">
              {!isLoginMode && (
                <div className="form-group">
                  <label htmlFor="name">Full Name</label>
                  <input
                    id="name"
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="John Doe"
                    required
                  />
                </div>
              )}
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                />
                {isLoginMode && ( // Only show "Forgot Password?" in login mode
                    <p  className="forgot-password-link " onClick={() => setShowRecoveryForm(true)}>
                        <span className='icon-btn'>Forgot Password?</span>
                    </p>
                )}
              </div>
              
              
              {error && <p className="auth-error">{error}</p>}
              
              <div className="auth-button-container">
                <button type="submit" className="auth-button" disabled={isLoading}>
                  {isLoading ? 'Processing...' : (isLoginMode ? 'Sign In' : 'Sign Up')}
                </button>
              </div>
            </form>
          ) : (
            // Password Recovery Form
            <form onSubmit={handlePasswordRecovery} className="auth-form">
              <h3 className="auth-subtitle">Reset Your Password</h3>
              <p className="auth-text-center">Enter your email address and we'll send you a link to reset your password.</p>
              <div className="form-group">
                <label htmlFor="recovery-email">Email Address</label>
                <input
                  id="recovery-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  required
                />
              </div>
              {recoveryMessage && <p className="auth-success">{recoveryMessage}</p>}
              {recoveryError && <p className="auth-error">{recoveryError}</p>}
              <div className="auth-button-container">
                <button type="submit" className="auth-button" disabled={isLoading}>
                  {isLoading ? 'Sending...' : 'Send Reset Link'}
                </button>
              </div>
              <p className="auth-link back-to-login-link" onClick={() => setShowRecoveryForm(false)}>
                  <ArrowLeft size={18} />
                  <span className='icon-btn'>Back to Login</span>
              </p>
              
            </form>
          )}
          
          {!showRecoveryForm && (
            <p className="auth-toggle">
              {isLoginMode ? "Don't have an account?" : 'Already have an account?'}
              <button onClick={() => setIsLoginMode(!isLoginMode)}>
                {isLoginMode ? 'Sign Up' : 'Sign In'}
              </button>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginPage;

